import { memo } from "react";
import { Dropdown } from "semantic-ui-react";

const CodeArrayEntry = memo(({ elementName, fieldLabel, startingValue, setResourceState, allowedValues, dataEntryStyle }) => {
  if (!allowedValues) {
    return <></>
  }
  return <div>
    <b>{fieldLabel}: </b>
    <Dropdown
      name={elementName}
      placeholder={fieldLabel}
      search={dataEntryStyle === "dropdownsearch"} multiple
      selection clearable selectOnBlur={false} autoComplete="off"
      style={{ minWidth: "25%", width: "25%" }}
      options={allowedValues.map((code, codeIndex) => { return { "key": codeIndex, "value": code, "text": code } })}
      value={startingValue}
      onChange={(e, data) => {
      setResourceState(prevState => { return { ...prevState, [elementName]: data.value }; });
      }}
    />
  </div>
});

export default CodeArrayEntry;